import React from "react";

import { colorTokens_latest } from "~styles/vars/colorTokens_latest";

import * as styles from "../styles.css";

import type { VariantBackgroundColorEnum } from "~styles/common/variant.backgroundColor.css";

export const getGridColors = (
  backgroundColor?: VariantBackgroundColorEnum | null
) => {
  let fill;

  if (backgroundColor === "background_white") {
    fill = colorTokens_latest.Primary.Lavender["100"].value;
  } else if (backgroundColor === "background_charcoal") {
    fill = colorTokens_latest.Primary.Lavender["150"].value;
  } else if (backgroundColor === "background_lavender") {
    fill = colorTokens_latest.Primary.Pure_white["100"].value;
  }

  return { fill };
};

export function SvgCardGridBackground({
  backgroundColor,
}: {
  backgroundColor: VariantBackgroundColorEnum;
}) {
  const { fill } = getGridColors(backgroundColor);

  return (
    <svg
      width="296"
      height="192"
      viewBox="0 0 296 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.reportSVGStyle}
    >
      <g>
        <path
          d="M246.226 -161.998L205.214 109.127C199.697 145.6 169.761 173.454 132.985 176.332L-97.9876 194.408C-148.068 198.327 -189.129 155.292 -182.865 105.451L-139.3 -241.149C-133.364 -288.38 -87.4493 -319.777 -41.2826 -308.176L187.138 -250.777C226.761 -240.821 252.337 -202.393 246.226 -161.998Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
